<template>
  <div id="contratos-toolbar-contratos">
    <v-toolbar flat>
      <template
        v-if="regresar">
        <v-tooltip
          top>
          <template
            v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              @click="botonRegresar">
              <v-icon>
                fa-arrow-left
              </v-icon>
            </v-btn>
          </template>
          <span>Regresar</span>
        </v-tooltip>
      </template>
      <v-toolbar-title class="display-1">
        {{ titulo }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <custom-button
        v-if="mostrarBotonPlantillas"
        label="Plantillas"
        iconText="mdi-file-word-outline"
        tipo="agregar"
        @click="generarNuevaPlantilla"
      >
      </custom-button>
      <custom-button
        class="ml-2"
        label="Estado de Cuenta"
        iconText="fa-file-pdf"
        tipo="agregar"
        @click="generarEstadoCuenta"
      >
      </custom-button>
    </v-toolbar>
    <v-dialog
      v-model="mostrarGenerarNuevaPlantilla"
      scrollable
      persistent
      width="800"
    >
      <generar-nueva-plantilla
        modulo="contratos"
        :datos="getDatos"
        :idarchivo="titulo"
        ref="generarNuevaPlantilla"
        @cerrarGenerarNuevaPlantilla="cerrarGenerarNuevaPlantilla"
      >
      </generar-nueva-plantilla>
    </v-dialog>

    <v-dialog
      v-model="mostrarGenerarEstadoCuenta"
      scrollable
      persistent
      width="600"
    >
      <generar-estado-cuenta
        ref="generarEstadoCuenta"
        @cerrarGenerarEstadoCuenta="cerrarGenerarEstadoCuenta"
      >
      </generar-estado-cuenta>
    </v-dialog>
  </div>
</template>

<script>
import CustomButton from '@/components/buttons/Button.vue';
import GenerarNuevaPlantilla from '@/components/administracion/configuracion/plantillas/generador/Default.vue';
import GenerarEstadoCuenta from '@/components/administracion/contratos/contrato/reportes/estadodecuenta/EstadoCuenta.vue';
import mixDatosContratos from '@/components/administracion/configuracion/plantillas/generador/mixDatosContratos';

export default {
  name: 'TituloToolBarContrato',
  components: { CustomButton, GenerarNuevaPlantilla, GenerarEstadoCuenta },
  mixins: [mixDatosContratos],
  props: {
    titulo: {
      type: String,
      required: false,
      default: '# Contrato',
    },
    datos: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
    fechas: {
      type: Array,
      required: true,
    },
    regresar: {
      type: Boolean,
      required: false,
      default: false,
    },
    nombreRuta: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      mostrarGenerarNuevaPlantilla: false,
      mostrarGenerarEstadoCuenta: false,
      mostrarBotonPlantillas: true,
    };
  },
  methods: {
    botonRegresar() {
      const { regresar, nombreRuta } = this;

      if (regresar && nombreRuta) {
        this.$router.push({ name: nombreRuta });
      } else {
        this.$router.back();
      }
    },
    generarNuevaPlantilla() {
      this.mostrarGenerarNuevaPlantilla = !this.mostrarGenerarNuevaPlantilla;
    },
    cerrarGenerarNuevaPlantilla() {
      this.generarNuevaPlantilla();
    },
    generarEstadoCuenta() {
      this.mostrarGenerarEstadoCuenta = !this.mostrarGenerarEstadoCuenta;
    },
    cerrarGenerarEstadoCuenta() {
      this.generarEstadoCuenta();
    },
  },
  computed: {
    getDatos() {
      if (!this.datos) return {};
      return this.formatoWordContrato(this.datos);
    },
  },
};
</script>

<style lang="scss">

</style>
